import { NO, YES } from "uicore-ts"


export class RHFilterSelection<FilterKey extends string> {

    readonly selectedKeys = new Set<FilterKey>()

    constructor(
        readonly mutuallyExclusiveKeys: readonly FilterKey[] = [],
        readonly narrowingKeys: readonly FilterKey[] = []
    ) {}

    toggleKey(key: FilterKey): void {
        if (this.mutuallyExclusiveKeys.includes(key)) {
            this.mutuallyExclusiveKeys.forEach(exclusiveKey => this.selectedKeys.delete(exclusiveKey))
            this.selectedKeys.add(key)
            return
        }
        if (this.selectedKeys.has(key)) {
            this.selectedKeys.delete(key)
        }
        else {
            this.selectedKeys.add(key)
        }
    }

    doesValueMatchSelection<Value>(
        value: Value,
        matchesKey: (value: Value, key: FilterKey) => boolean
    ): boolean {
        let hasUnionSelection = NO
        let doesValueMatchUnionSelection = NO
        for (const key of this.selectedKeys) {
            const doesValueMatchKey = matchesKey(value, key)
            if (this.mutuallyExclusiveKeys.includes(key) || this.narrowingKeys.includes(key)) {
                if (!doesValueMatchKey) {
                    return NO
                }
            }
            else {
                hasUnionSelection = YES
                doesValueMatchUnionSelection = doesValueMatchUnionSelection || doesValueMatchKey
            }
        }
        return !hasUnionSelection || doesValueMatchUnionSelection
    }

    selectionForCountingKey(key: FilterKey): RHFilterSelection<FilterKey> {
        let keysToRemove = [...this.selectedKeys].filter(selectedKey =>
            !this.mutuallyExclusiveKeys.includes(selectedKey) && !this.narrowingKeys.includes(selectedKey)
        )
        if (this.mutuallyExclusiveKeys.includes(key)) {
            keysToRemove = [...this.mutuallyExclusiveKeys]
        }
        else if (this.narrowingKeys.includes(key)) {
            keysToRemove = [key]
        }
        const selection = new RHFilterSelection(this.mutuallyExclusiveKeys, this.narrowingKeys)
        for (const selectedKey of this.selectedKeys) {
            if (!keysToRemove.includes(selectedKey)) {
                selection.selectedKeys.add(selectedKey)
            }
        }
        selection.selectedKeys.add(key)
        return selection
    }

}
